<label for="{{ id }}" *ngIf="label">{{ label }}</label>
<input
  #slideInput
  type="range"
  [formControl]="ctrl"
  class="custom-range"
  [min]="min"
  [max]="max"
  [step]="step"
  id="{{ id }}"
/>
